import React from 'react';

export default function LoadingScreen(props) {
  return <div>Loading...</div>;
}
